import React from 'react'
import { Button } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationCrosshairs } from '@fortawesome/free-solid-svg-icons'
import MapComponent from '../../../components/map-component/MapComponent'

interface MapSelectorProps {
  position: L.LatLng | null
  setPosition: (pos: L.LatLng | null) => void
  coordinates: Partial<L.LatLng>
  showMyLocation: boolean
  setLocationFunction: (func: any) => void
  mapError: boolean
  t: (key: string) => string
  loading: boolean
}

const MapSelector: React.FC<MapSelectorProps> = ({
  position,
  setPosition,
  coordinates,
  showMyLocation,
  setLocationFunction,
  mapError,
  t,
  loading,
}) => (
  <div className="checkout-page__container-location-map-container">
    <div className={`checkout-page__container-location-map ${mapError ? 'map-error' : ''}`}>
      <MapComponent
        position={position}
        setPosition={setPosition}
        coordinates={coordinates}
        showMyLocation={showMyLocation}
        setLocationFunction={setLocationFunction}
      />
      <div className="checkout-page__container-location-map-text">
        {t('SELECT_DELIVERY_LOCATION')}
      </div>
      <div className="checkout-page__container-location-map-current">
        <Button
          variant="contained"
          disabled={loading}
          onClick={() => setLocationFunction(() => null)}
          sx={{
            backgroundColor: '#ff1647',
            textTransform: 'none',
            fontSize: '16px',
            fontWeight: 'bold',
            width: '100%',
            display: 'flex',
            gap: '10px',
            opacity: 0.5,
            '&:hover': { backgroundColor: '#cc1138' },
          }}
        >
          <FontAwesomeIcon icon={faLocationCrosshairs} /> {t('SHOW_MY_LOCATION')}
        </Button>
      </div>
    </div>
    {mapError && <p className="map-error-text">{t('MAP_ERROR')}</p>}
  </div>
)

export default MapSelector